/**
 * @fileoverview Banner fino de contagem do período de teste. Mostra os dias
 * restantes a partir de billing.trial_end. Aparece só quando há trial vigente
 * (status teste_gratis e não bloqueado). Renderizado no topo do <main>.
 */

import React, { useState } from "react";
import { makeStyles } from "@material-ui/core";
import { Clock, X } from "lucide-react";

import { i18n } from "../../../translate/i18n";
import { useOnboarding } from "../../../context/Onboarding/OnboardingContext";

const useStyles = makeStyles(() => ({
  banner: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 10,
    padding: "8px 16px",
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "0.85rem",
    fontWeight: 500,
    color: "#fff",
    background: "linear-gradient(135deg, #142966 0%, #010616 100%)",
    position: "relative"
  },
  warn: { background: "linear-gradient(135deg, #f59e0b 0%, #ef4444 100%)" },
  close: {
    position: "absolute",
    right: 10,
    cursor: "pointer",
    opacity: 0.85,
    display: "flex",
    "&:hover": { opacity: 1 }
  }
}));

const daysLeft = trialEnd => {
  if (!trialEnd) return null;
  const end = new Date(trialEnd);
  if (Number.isNaN(end.getTime())) return null;
  const ms = end.getTime() - Date.now();
  return Math.max(0, Math.ceil(ms / (1000 * 60 * 60 * 24)));
};

const TrialCountdownBanner = () => {
  const classes = useStyles();
  const { billing } = useOnboarding();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed || !billing || billing.blocked) return null;
  if (billing.status !== "teste_gratis" || !billing.trial_end) return null;

  const d = daysLeft(billing.trial_end);
  if (d === null) return null;

  const label =
    d <= 0
      ? i18n.t("onboarding.trial.lastDay")
      : `${d} ${d === 1 ? i18n.t("onboarding.trial.dayLeft") : i18n.t("onboarding.trial.daysLeft")}`;

  return (
    <div className={`${classes.banner} ${d <= 2 ? classes.warn : ""}`}>
      <Clock size={16} />
      {i18n.t("onboarding.trial.prefix")} {label}
      <span className={classes.close} onClick={() => setDismissed(true)} title={i18n.t("onboarding.minimize")}>
        <X size={16} />
      </span>
    </div>
  );
};

export default TrialCountdownBanner;
